import "./ghl-ui.es329.js";
import "./ghl-ui.es330.js";
import "./ghl-ui.es331.js";
import "./ghl-ui.es332.js";
import "./ghl-ui.es333.js";
import "./ghl-ui.es334.js";
import "./ghl-ui.es335.js";
import "./ghl-ui.es336.js";
import "./ghl-ui.es337.js";
import "./ghl-ui.es338.js";
import "./ghl-ui.es339.js";
import "./ghl-ui.es340.js";
import "./ghl-ui.es341.js";
import "./ghl-ui.es342.js";
import e from "./ghl-ui.es343.js";
import "./ghl-ui.es344.js";
function v(o) {
  const r = document.querySelectorAll(".n-data-table-tbody");
  if (r.length === 0)
    return null;
  const t = {
    draggable: ".n-data-table-tr",
    mirror: {
      appendTo: r,
      constrainDimensions: !0
    },
    delay: 300,
    classes: {
      mirror: "draggable-mirror",
      "body:dragging": "",
      "container:dragging": "",
      "source:dragging": "",
      "source:placed": "",
      "container:placed": "",
      "draggable:over": "",
      "container:over": "",
      "source:original": ""
    }
  };
  return o && (t.handle = `.${o}`), new e(r, t);
}
export {
  v as default
};
